/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Board_States_DescriptionInputs */



/**
* | output |
* | --- |
* | "Game situations drawn step by step" |
*
* @param {Nav_Board_States_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_board_states_description = /** @type {((inputs?: Nav_Board_States_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Board_States_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spielsituationen Schritt für Schritt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Situations de jeu illustrées étape par étape")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("逐步绘制的对局情形")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("逐步繪製的對局情境")
	if (locale === "ko") return /** @type {LocalizedString} */ ("단계별로 그려진 게임 상황")
	return /** @type {LocalizedString} */ ("Game situations drawn step by step")
});